import { useEffect } from 'react';

const useDisableScrollRestoration = () => {
  useEffect(() => {
    window.history.scrollRestoration = 'manual';
  }, []);
};

export default useDisableScrollRestoration;
